import React from 'react';

import {
  useTranslation,
} from 'react-i18next';

import './BrandSection.css';

const PUBLIC_URL =
  process.env.PUBLIC_URL || '';

const LOGIN_VIDEO_PATH =
  `${PUBLIC_URL}/videos/login-background.mp4`;

const LOGIN_VIDEO_KOR_PATH =
  `${PUBLIC_URL}/videos/login-background_kr.mp4`;

export default function BrandSection() {
  const {
    i18n,
  } = useTranslation('app');

  const currentLanguage =
    i18n.resolvedLanguage ||
    i18n.language ||
    'en';

  const loginVideoPath =
    currentLanguage.startsWith('ko')
      ? LOGIN_VIDEO_KOR_PATH
      : LOGIN_VIDEO_PATH;

  return (
    <section className="login-brand-section">
      <video
        className="login-brand-video"
        autoPlay
        muted
        loop
        playsInline
        key={loginVideoPath}
      >
        <source
          src={loginVideoPath}
          type="video/mp4"
        />
      </video>

      <div className="login-brand-video-overlay" />

      <div className="login-brand-decoration">
        <span className="login-brand-decoration-circle is-large" />
        <span className="login-brand-decoration-circle is-small" />
        <span className="login-brand-decoration-line" />
      </div>
    </section>
  );
}